export class EmployeePaymentsDataDto {
    empName: string;
    workingDays: number;
    otHrs: number;
    subContractors:number;
    projectId:number;
  }